import { makeStyles } from "@material-ui/core/styles";
export var useStyles = makeStyles(function (theme) { return ({
    gridRoot: {
        paddingBottom: "10px",
        paddingLeft: "14px",
        paddingRight: "14px",
        paddingTop: "10px",
    },
    gridRow: {
        padding: "8px",
    },
    label: {
        fontSize: "12px",
        fontWeight: 400,
        marginTop: "10px",
        textAlign: "center",
    },
    root: {
        marginTop: "40px",
    },
    select: {
        color: "#6D7781",
        fontSize: "16px",
        fontWeight: 400,
    },
    button: {
        "&.Mui-disabled": {
            backgroundColor: theme.palette.primary.main,
            color: "#FFFFFF",
        },
    },
    typePerson: {
        color: "#6D7781",
        paddingRight: "70px",
    },
    textToggle: {
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "140%",
    },
    toggleBtn: {
        "&.Mui-selected": {
            textTransform: "none",
            border: "0.6px solid",
            borderColor: theme.palette.primary.main,
            boxSizing: "border-box",
            backgroundColor: theme.palette.primary.main,
            color: "white",
            height: "30px",
            width: "100%",
        },
        width: "100%",
        textTransform: "none",
        border: "0.6px solid",
        borderColor: theme.palette.primary.main,
        boxSizing: "border-box",
        borderRadius: "5px",
        backgroundColor: "white",
        color: theme.palette.primary.main,
        height: "30px",
    },
}); });
